<fieldset>
  <legend>Typ záboru</legend>
  <gmt-switch [options]="occupationTypeOptions" [selectedId]="occupationType" (selectedIdChange)="onTypeChange($event)"></gmt-switch>
</fieldset>

<div [loading]="loading">
  <div *ngIf="!loading">
    <div *ngIf="occupations?.length">
      <div class="jumbotron text-center">
        Nalezen{{ occupations.length === 1 ? '' : 'o' }} <strong>{{ occupations.length }}</strong> zábor{{ occupations.length === 1 ? '' : 'ů' }}, u kterch lze zadat cenu. Níže vyplňte údaje o ceně.
      </div>

      <ng-container *ngIf="occupationType === 'u' || occupationType === 'o'">
        <fieldset>
          <legend>Způsob určení ceny</legend>
          <gmt-switch [options]="priceTypeRental" [(selectedId)]="rentalPrice.rentalPriceType"></gmt-switch>
        </fieldset>

        <fieldset>
          <legend>Cena</legend>
          <div class="column-100" *ngIf="assessment || !useAssessment || rentalPrice.rentalPriceType !== 'F'">
            <label class="required">Délka nájmu [<span class="unit">měsíce</span>]</label>
            <div class="input"><input type="text" [(ngModel)]="rentalPrice.rentalLength" gmtInputNumber/></div>
          </div>

          <div class="column-100">
            <ng-container *ngIf="rentalPrice.rentalPriceType === 'F' && !useAssessment">
              <label class="required">Rok cenového výměru MF</label>
              <div class="input"><input type="text" [(ngModel)]="rentalPrice.priceAssessmentYear" gmtInputNumber/></div>
            </ng-container>

            <ng-container  *ngIf="rentalPrice.rentalPriceType === 'F' && useAssessment && assessment">
              <label>Rok cenového výměru MF</label>
              <div class="info">{{assessment.year}}</div>
            </ng-container>

            <ng-container  *ngIf="rentalPrice.rentalPriceType === 'E'">
              <label class="required">Číslo znaleckého posudku</label>
              <div class="input"><input type="text" [(ngModel)]="rentalPrice.rentalExpertOpinionNumber"/></div>

              <label class="required">Datum znaleckého posudku</label>
              <div class="input"><input type="text" pick-a-date [(ngModel)]="rentalPrice.rentalExpertOpinionDate"/></div>
            </ng-container>

            <ng-container  *ngIf="rentalPrice.rentalPriceType === 'O'">
              <label class="required">Původ ceny</label>
              <div class="input"><input type="text" [(ngModel)]="rentalPrice.rentalOtherPriceSource"/></div>
              <div class="column-100">
                <label class="required">Způsob výpočtu ceny</label>
                <gmt-switch [options]="priceUnitRental" [(selectedId)]="rentalPrice.rentalPriceUnit"></gmt-switch>
              </div>
            </ng-container>

            <ng-container  *ngIf="rentalPrice.rentalPriceType === 'O' && rentalPrice.rentalPriceUnit === 'T'">
              <label class="required">Cena za pozemek [<span class="unit">Kč</span>]</label>
              <div class="input"><input type="text" [(ngModel)]="rentalPrice.totalRentPrice" gmtInputNumber/></div>
            </ng-container>

            <ng-container *ngIf="(rentalPrice.rentalPriceType !== 'O' || rentalPrice.rentalPriceUnit !== 'T') && (rentalPrice.rentalPriceType !== 'F' || !useAssessment)">
              <label class="required">Cena za pozemek [<span class="unit">Kč/m<sup>2</sup>/rok</span>]</label>
              <div class="input"><input type="text" [(ngModel)]="rentalPrice.priceAssessmentLandPrice" gmtInputNumber/></div>
            </ng-container>

            <ng-container *ngIf="rentalPrice.rentalPriceType === 'F' && useAssessment">
              <div *ngIf="!assessment"><span class="error-message mr-10"><i class="fa fa-exclamation-triangle"></i></span> Nejsou zadané ceny za m<sup>2</sup> v jednotlivých katastrálních územích a další potřebné údaje v Kartě akce, v záložce <a uiSref="symap.project.info" [uiParams]="{tab: 'price-assessment'}">Výměry MF pro ceny za nájmy</a></div>
              <ng-container *ngIf="assessment">
                <label>Cena za pozemek [<span class="unit">Kč/m<sup>2</sup>/rok</span>]</label>
                <div class="info"><div *ngFor="let area of areas"><label>{{area.name}}</label><div class="info">{{assessment.price[area.id]}}</div></div></div>
              </ng-container>
            </ng-container>
          </div>
        </fieldset>

        <expert-select-form *ngIf="rentalPrice.rentalPriceType === 'E'" [expert]="rentalPrice.rentalExpert" (changed)="onChangeExpert($event)"></expert-select-form>
      </ng-container>

      <ng-container *ngIf="occupationType === 'p'">
        <fieldset>
          <legend>Způsob určení ceny</legend>
          <gmt-switch [options]="priceTypePurchase" [(selectedId)]="purchasePrice.priceType"></gmt-switch>
        </fieldset>

        <fieldset>
          <legend>Způsob zadání ceny za pozemek</legend>
          <gmt-switch [options]="priceUnitPurchase" [(selectedId)]="purchasePrice.priceUnit"></gmt-switch>
        </fieldset>

        <fieldset>
          <legend>Cena</legend>
          <div class="column-100">
            <label class="required">Původ ceny</label>
            <div class="input"><input type="text" [(ngModel)]="purchasePrice.otherSource"/></div>

            <label class="required">Cena za pozemek</label>
            <div class="input"><input type="text" [(ngModel)]="purchasePrice.price" gmtInputNumber/> <span class="unit"> Kč<ng-container *ngIf="purchasePrice.priceUnit === 'M'">/m<sup>2</sup></ng-container></span></div>
          </div>
        </fieldset>
      </ng-container>
    </div>

    <div *ngIf="occupations && !occupations.length" class="jumbotron text-center">
      Nebyl nalezen žádný zábor u kterého by šla nastavit cena.
    </div>

    <div class="mt-10">
      <gmt-button [clickAction]="onSubmit" [gmtDisabled]="!isValid()">Dále</gmt-button>
    </div>
  </div>
</div>
